import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { trackEvent, EVENT_TYPE_PAGE } from '../utils/trackEvent.jsx';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { motion } from 'framer-motion';
import { colors, semanticColors } from '@/constants/colors.jsx';

const Partner = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    trackEvent(EVENT_TYPE_PAGE);
    console.log('Partner page loaded - tracking page view');
  }, []);

  const handleContactClick = () => {
    console.log('Contact button clicked - redirecting to email');
    window.location.href = 'mailto:salaam@halalcred.com?subject=Partner%20Inquiry';
  };

  return (
    <div className="min-h-screen bg-gradient-to-r from-[#f8fafc] to-[#e2e8f0] py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        {/* Header Section */}
        <motion.div 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h1 className="text-4xl md:text-5xl font-bold text-[#1a4a1a] mb-6">
            Welcome to Partner Page
          </h1>
          <p className="text-xl text-[#1a4a1a]/90 max-w-3xl mx-auto leading-relaxed">
            Join us in our mission to make halal financing accessible to everyone. 
            Become a trusted partner in connecting communities with Islamic financing products.
          </p>
        </motion.div>

                  {/* Partnership Mission Section */}
          <motion.div 
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="mb-12"
          >
            <Card className="bg-gradient-to-r from-emerald-50 to-green-50 border-2 border-emerald-200">
              <CardContent className="p-8 text-center">
                <div className="text-4xl mb-4">🤝</div>
                <h3 className="text-lg md:text-xl text-[#1a4a1a] font-medium mb-4">
                  Our Partnership Mission
                </h3>
                <p className="text-sm text-[#1a4a1a]/70">
                  Building lasting partnerships based on trust, transparency, and mutual growth
                </p>
              </CardContent>
            </Card>
          </motion.div>

        {/* Partnership Benefits */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12"
        >
          <Card className="hover:shadow-lg transition-all duration-300">
            <CardContent className="p-6 text-center">
              <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">🤝</span>
              </div>
              <h3 className="text-xl font-semibold text-[#1a4a1a] mb-3">Trusted Partnership</h3>
              <p className="text-[#1a4a1a]/80">
                Build lasting relationships with a community committed to Islamic financing principles.
              </p>
            </CardContent>
          </Card>

          <Card className="hover:shadow-lg transition-all duration-300">
            <CardContent className="p-6 text-center">
              <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">📈</span>
              </div>
              <h3 className="text-xl font-semibold text-[#1a4a1a] mb-3">Growth Opportunities</h3>
              <p className="text-[#1a4a1a]/80">
                Access a growing market of individuals and businesses seeking halal financial solutions.
              </p>
            </CardContent>
          </Card>

          <Card className="hover:shadow-lg transition-all duration-300">
            <CardContent className="p-6 text-center">
              <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">🌍</span>
              </div>
              <h3 className="text-xl font-semibold text-[#1a4a1a] mb-3">Community Impact</h3>
              <p className="text-[#1a4a1a]/80">
                Make a positive difference by helping communities access ethical financial services.
              </p>
            </CardContent>
          </Card>
        </motion.div>

        {/* Call to Action */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="text-center"
        >
          <Card className="bg-gradient-to-r from-emerald-500 to-emerald-600 text-white">
            <CardContent className="p-8">
              <h2 className="text-2xl md:text-3xl font-bold mb-4">
                Ready to Partner With Us?
              </h2>
              <p className="text-lg mb-6 opacity-90">
                Let's discuss how we can work together to serve the Islamic financing community.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button
                  onClick={() => navigate('/partner-signup')}
                  className="bg-white text-emerald-600 hover:bg-gray-100 font-semibold px-8 py-3 rounded-full transition-all duration-200 transform hover:scale-105 shadow-lg"
                >
                  Become a Partner
                </Button>
                <Button
                  onClick={() => navigate('/partner-signin')}
                  variant="outline"
                  className="border-white text-white hover:bg-white hover:text-emerald-600 font-semibold px-8 py-3 rounded-full transition-all duration-200 transform hover:scale-105"
                >
                  Partner Login
                </Button>
              </div>
            </CardContent>
          </Card>
        </motion.div>

        {/* Additional Information */}
        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.8 }}
          className="mt-12 text-center"
        >
          <p className="text-[#1a4a1a]/70 text-sm">
            More detailed partnership information and application process coming soon.
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default Partner; 